import React from "react";
import { createRoot } from "react-dom/client";

// Les fontes AVANT le reste : elles sont servies depuis notre domaine, et leur
// déclaration doit précéder la feuille qui les référence.
//
// POINT D'EXTENSION — une seule fonte pour l'instant, celle de l'interface.
// Le caractère de titrage du château viendra s'ajouter ici, et se déclarer
// dans `typography.css`.
import "@fontsource-variable/inter";
// L'écran d'accueil : interface en Raleway (voir `--police-splash-*`). Le titre,
// lui, est Casablanca, déclarée en `@font-face` dans `typography.css`.
import "@fontsource-variable/raleway";
import "./typography.css";

import { App } from "./App.js";

const racine = createRoot(document.getElementById("root")!);
const params = new URLSearchParams(window.location.search);

if (params.has("reproject")) {
  // L'outil de reprojection : à la demande (rien dans le bundle de la visite), et SANS
  // le document de la visite — il n'en lit ni n'en écrit aucun.
  void import("./Reprojection.js").then(({ Reprojection }) =>
    racine.render(<Reprojection sceneId={params.get("scene")} />),
  );
} else {
  racine.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
